import React from 'react';

const Percents = (props) => {
    const { pct, setPct, percents, isDisabled } = props;

    return (
        <div className='form-group col-4 col-md-12'>
            <label>Grad:</label>
            <select className='form-control' value={pct} disabled={isDisabled} onChange={(event) => setPct(parseInt(event.target.value))}>
                {percents.map((p) => (
                    <option value={p} key={p}>{`${p} %`}</option>
                ))}
            </select>
        </div>
    );
};

export default Percents;
